import React, { MutableRefObject, useEffect, useRef, useState } from "react";
import { Typography } from "@progress/kendo-react-common";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  getFlightBooingsByOptions,
  getFlightBooingsBySearch,
  sendMailByBookingNo,
  sendWhatsappByBookingNo,
} from "./services/flightBooking.services";
import {
  GridLayout,
  GridLayoutItem,
  TabStrip,
  TabStripSelectEventArguments,
  TabStripTab,
} from "@progress/kendo-react-layout";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import {
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  Grid as KendoGrid,
  GridColumn as Column,
  GridCellProps,
} from "@progress/kendo-react-grid";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { LoadingPanel } from "../../components/layout/Loading";
import AlertBox from "../../components/common/AlertBox";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import { Link, useNavigate } from "react-router-dom";
// import ButtonForAll from "../../components/common/Button";
import TabStripTitle from "../../components/common/TabStripTitle";
import {
  clearFlightBookingListByOptions,
  clearFlightBookingSearchFilter,
  setFlightBookingSearchFilter,
  setFlightBookingTab,
} from "./flightBookingSlice";
import ShadowCard from "../../components/common/ShadowCard";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import FormSelectionField from "../../components/formFields/FormSelectionField";
// import {
//   requiredArrayValidator,
//   requiredValidator,
// } from "../../components/formFields/CommonValidator";
import {
  BOOKING_SEARCH_TYPE,
  EMAIL_SEND_ACCESS,
  EXCEL_EXPORT_ACCESS,
  MONTHARRAY,
  SEARCH_TYPE,
  WHATSAPP_SEND_ACCESS,
  YEARARRAY,
} from "../../_contstants/common";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import FormCheckboxGroup from "../../components/formFields/FormCheckboxGroup";
import FormDatePicker from "../../components/formFields/FormDateField";
import moment from "moment";
import FormTextField from "../../components/formFields/FormTextField";
import FormRadioGroup from "../../components/formFields/FormRadioGroup";
import {
  // requiredArrayValidator,
  requiredValidator,
} from "../../components/formFields/CommonValidator";
import {
  Button,
  DropDownButton,
  // DropDownButtonItem,
} from "@progress/kendo-react-buttons";
import {
  checkAcessRights,
  formatIndianNumber,
  getRequestId,
} from "../../_helper/helper";
import { API_URL } from "../../app/config";
import { ErrorToast } from "../../components/toast/Toasts";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { MdMail } from "react-icons/md";
import { IoLogoWhatsapp } from "react-icons/io";
import IconButton from "../../components/common/IconButton";
// import { printIcon } from "@progress/kendo-svg-icons";

interface ChangeWatcherProps {
  formRenderProps: FormRenderProps;
}

const FlightBooking: React.FC = () => {
  const dispatch = useAppDispatch();
  const FlightBookingTabIndex = useAppSelector(
    (state) => state.flightBooking.FlightBookingTabIndex
  );
  const FlightBookingSearchFilter = useAppSelector(
    (state) => state.flightBooking.FlightBookingSearchFilter
  );
  const gridRef = useRef<any>(null);
  const loading = useAppSelector((state) => state.flightBooking.loading);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const isExcelExportAccess = checkAcessRights(
    location.pathname,
    EXCEL_EXPORT_ACCESS
  );

  const [formKey, setFormKey] = React.useState(1);

  useEffect(() => {
    return () => {
      dispatch(clearFlightBookingSearchFilter());
    };
  }, []);

  const exportRef = React.useRef<ExcelExport | null>(null);
  const excelExport = () => {
    if (exportRef.current !== null) {
      exportRef.current.save();
    }
  };

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [FlightBookingTabIndex]);

  const handleSelect = (e: TabStripSelectEventArguments) => {
    dispatch(setFlightBookingTab(e.selected));
    if (e.selected === 0) {
      dispatch(
        setFlightBookingSearchFilter({
          ...FlightBookingSearchFilter,
          Month: moment().month() + 1,
          Year: moment().year(),
          FromDate: "",
          ToDate: "",
          SearchText: "",
        })
      );
    } else if (e.selected === 1) {
      dispatch(
        setFlightBookingSearchFilter({
          ...FlightBookingSearchFilter,
          FromDate: moment().toDate(),
          ToDate: moment().toDate(),
          Month: 0,
          Year: 0,
          SearchText: "",
        })
      );
    } else if (e.selected === 2) {
      dispatch(
        setFlightBookingSearchFilter({
          ...FlightBookingSearchFilter,
          Month: 0,
          Year: 0,
          FromDate: "",
          ToDate: "",
          Status: [],
          Search: "",
        })
      );
      dispatch(clearFlightBookingListByOptions());
    }
  };

  const handleSubmit = async (values: any) => {
    try {
      if (FlightBookingTabIndex === 2) {
        const payload = {
          MobileNo: values?.SearchType === "MobileNo" ? values?.SearchText : "",
          AirlinePNR:
            values?.SearchType === "AirlinePNR" ? values?.SearchText : "",
          RefNo: values?.SearchType === "RefNo" ? values?.SearchText : "",
          Limit: 100,
          Skip: 0,
        };
        dispatch(
          setFlightBookingSearchFilter({
            ...FlightBookingSearchFilter,
            SearchText: values.SearchText,
            SearchType: values.SearchType,
          })
        );
        dispatch(getFlightBooingsByOptions(payload));
      } else {
        const payload = {
          Search: values.Search,
          Status: values?.Status?.join(", "),
          Limit: pageLimit,
          Skip: 0,
          Month: FlightBookingTabIndex === 0 ? values.Month : 0,
          Year: FlightBookingTabIndex === 0 ? values.Year : 0,
          FromDate:
            FlightBookingTabIndex === 1 && values.FromDate
              ? moment(values.FromDate).format("YYYY-MM-DD")
              : "",
          ToDate:
            FlightBookingTabIndex === 1 && values.ToDate
              ? moment(values.ToDate).format("YYYY-MM-DD")
              : "",
        };
        dispatch(setCurrentPage(0));
        dispatch(
          setFlightBookingSearchFilter({
            ...FlightBookingSearchFilter,
            ...payload,
            Status: values?.Status,
          })
        );
        dispatch(getFlightBooingsBySearch(payload));
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <GridLayout cols={[{ width: "100%" }]}>
        <Form
          key={formKey}
          onSubmit={handleSubmit}
          initialValues={FlightBookingSearchFilter}
          render={(formRenderProps: FormRenderProps) => (
            <FormElement style={{ width: "100%" }}>
              <ShadowCard
                style={{ marginBottom: 20, padding: 0, borderRadius: 0 }}
              >
                <GridLayoutItem>
                  <TabStrip
                    selected={FlightBookingTabIndex}
                    onSelect={handleSelect}
                    className="client-grid"
                  >
                    <TabStripTab
                      title={<TabStripTitle title={`Search By Month`} />}
                      contentClassName="p-0"
                    >
                      <SerchByMonthAndDateRangeForm
                        formRenderProps={formRenderProps}
                      />
                    </TabStripTab>
                    <TabStripTab
                      title={<TabStripTitle title={`Search By Date Range`} />}
                      contentClassName="p-0"
                    >
                      <SerchByMonthAndDateRangeForm
                        formRenderProps={formRenderProps}
                      />
                    </TabStripTab>
                    <TabStripTab
                      title={<TabStripTitle title={`Search By Options`} />}
                      contentClassName="p-0"
                    >
                      <SearchByOptionForm formRenderProps={formRenderProps} />
                    </TabStripTab>
                  </TabStrip>
                </GridLayoutItem>
              </ShadowCard>
              <ShadowCard>
                <GridLayoutItem
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "0 0 10px",
                  }}
                >
                  <Typography.h4
                    style={{
                      marginBottom: 0,
                      marginLeft: "3px",
                      color: "#000",
                    }}
                  >
                    Flight Booking List
                  </Typography.h4>
                  {FlightBookingTabIndex !== 2 && (
                    <div style={{ display: "flex", gap: 10, width: "40%" }}>
                      <div style={{ width: "calc(100% - 51px)" }}>
                        <Field
                          name="Search"
                          component={FormTextField}
                          placeholder="Search here..."
                        />
                      </div>
                      <ButtonWithLoading
                        style={{ marginTop: 15, marginLeft: "auto" }}
                        label={"Search"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit}
                        loading={loading}
                      />
                      {isExcelExportAccess && (
                        <Button
                          title="Export Excel"
                          themeColor={"primary"}
                          type="button"
                          onClick={excelExport}
                          style={{ marginTop: 15 }}
                        >
                          Export to Excel
                        </Button>
                      )}
                    </div>
                  )}
                </GridLayoutItem>

                {FlightBookingTabIndex === 2 ? (
                  <GridLayoutItem
                    style={{
                      maxHeight: "calc(-360px + 100vh)",
                      overflowY: "auto",
                    }}
                  >
                    <OptionWiseFlightBookingGridComponent />
                  </GridLayoutItem>
                ) : (
                  <GridLayoutItem>
                    <FlightBookingsGridComponent exportRef={exportRef} />
                  </GridLayoutItem>
                )}
              </ShadowCard>
            </FormElement>
          )}
        />
      </GridLayout>
    </>
  );
};
interface PageState {
  skip: number;
  take: number;
}
const initialDataState: PageState = { skip: 0, take: 10 };

const SerchByMonthAndDateRangeForm: React.FC<ChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const FlightBookingTabIndex = useAppSelector(
    (state) => state.flightBooking.FlightBookingTabIndex
  );

  const loading = useAppSelector((state) => state.flightBooking.loading);

  return (
    <GridLayout
      style={{
        marginRight: "20px",
        padding: "10px",
      }}
      gap={{ rows: 0, cols: 10 }}
      cols={[{ width: "33.33%" }, { width: "33.33%" }, { width: "33.33%" }]}
    >
      <GridLayoutItem className="flight-search-checkbox-griditem">
        <Typography.h5
          style={{ borderBottom: "1px dashed gray", paddingBottom: 10 }}
        >
          Booking Type
        </Typography.h5>
        <Field
          id={"Status"}
          name={"Status"}
          label={"Status"}
          component={FormCheckboxGroup}
          options={BOOKING_SEARCH_TYPE}
          // validator={requiredArrayValidator}
        />
      </GridLayoutItem>
      <GridLayoutItem style={{ width: "100%" }}>
        {FlightBookingTabIndex === 0 ? (
          <>
            <Field
              id={"Month"}
              name={"Month"}
              component={FormSelectionField}
              label={"Month"}
              // validator={requiredValidator}
              // astrike={true}
              options={MONTHARRAY?.map((status: any) => {
                return {
                  value: status.value,
                  label: status.label,
                };
              })}
            />
            <Field
              id={"Year"}
              name={"Year"}
              component={FormSelectionField}
              label={"Year"}
              // validator={requiredValidator}
              // astrike={true}
              options={YEARARRAY?.map((status: any) => {
                return {
                  value: status.value,
                  label: status.label,
                };
              })}
            />
          </>
        ) : (
          <>
            <Field
              id={"FromDate"}
              name={"FromDate"}
              component={FormDatePicker}
              label={"From Date"}
              // validator={requiredValidator}
              // astrike={true}
            />
            <Field
              id={"ToDate"}
              name={"ToDate"}
              component={FormDatePicker}
              label={"To Date"}
              minDate={moment(formRenderProps.valueGetter(`FromDate`)).toDate()}
              // validator={requiredValidator}
              // astrike={true}
            />
          </>
        )}
        <div style={{ textAlign: "end" }}>
          <ButtonWithLoading
            style={{ marginTop: 20, marginLeft: "auto" }}
            label={"Search"}
            type="submit"
            disabled={!formRenderProps.allowSubmit}
            loading={loading}
          />
        </div>
      </GridLayoutItem>
    </GridLayout>
  );
};

const SearchByOptionForm: React.FC<ChangeWatcherProps> = ({
  formRenderProps,
}) => {
  // const FlightBookingTabIndex = useAppSelector(
  //   (state) => state.flightBooking.FlightBookingTabIndex
  // );

  const loading = useAppSelector((state) => state.flightBooking.loading);

  return (
    <GridLayout
      style={{
        marginRight: "20px",
        padding: "10px",
      }}
      gap={{ rows: 0, cols: 10 }}
      cols={[{ width: "33.33%" }, { width: "33.33%" }, { width: "33.33%" }]}
    >
      <GridLayoutItem
        className="flight-search-radio-griditem"
        colSpan={3}
        style={{ maxWidth: 400 }}
      >
        <Field
          id={"SearchType"}
          name={"SearchType"}
          component={FormRadioGroup}
          options={SEARCH_TYPE}
          validator={requiredValidator}
        />
      </GridLayoutItem>
      <GridLayoutItem
        style={{ maxWidth: 300, display: "flex", gap: 20 }}
        colSpan={2}
      >
        <div style={{ width: "calc(100% - 60px)" }}>
          <Field
            id={"SearchText"}
            name={"SearchText"}
            component={FormTextField}
            placeholder={"Search here..."}
            validator={requiredValidator}
            // astrike={true}
          />
        </div>
        <ButtonWithLoading
          style={{ marginTop: 15, marginLeft: "auto" }}
          label={"Search"}
          type="submit"
          disabled={!formRenderProps.allowSubmit}
          loading={loading}
        />
      </GridLayoutItem>
    </GridLayout>
  );
};

interface FlightBookingsGridProps {
  exportRef: MutableRefObject<ExcelExport | null>;
}

const FlightBookingsGridComponent: React.FC<FlightBookingsGridProps> = ({
  exportRef,
}) => {
  const dispatch = useAppDispatch();
  const FlightBookingList = useAppSelector(
    (state) => state.flightBooking.FlightBookingList
  );
  const FlightBookingSearchFilter = useAppSelector(
    (state) => state.flightBooking.FlightBookingSearchFilter
  );

  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const isWhatsAppSendAccess = checkAcessRights(
    location.pathname,
    WHATSAPP_SEND_ACCESS
  );
  const isEmailSendAccess = checkAcessRights(
    location.pathname,
    EMAIL_SEND_ACCESS
  );

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);
  const [page, setPage] = React.useState<PageState>(initialDataState);

  useEffect(() => {
    dispatch(
      getFlightBooingsBySearch({
        ...FlightBookingSearchFilter,
        Status: FlightBookingSearchFilter?.Status?.join(", "),
        Limit: +pageLimit,
        Skip: +currentPage * +pageLimit,
      })
    );
  }, [currentPage, pageLimit]);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  // const MyEditCommandCell = (props: GridCellProps) => {
  //   const PortalBookingNo = props.dataItem?.PortalBookingNo;
  //   return (
  //     <td
  //       className={`action-td ${props.className}`}
  //       style={{
  //         ...props.style,
  //       }}
  //     >
  //       <Link to={`view/${PortalBookingNo}`} type="button" >
  //         {/* <ButtonForAll fillMode="solid" label="View" themeColor="primary" /> */}
  //       </Link>
  //     </td>
  //   );
  // };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      style={props.thProps?.style}
      className={`table-header booking-table-header ${
        props.index === 11 ? "locked-header" : ""
      }`}
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td
        style={{ ...props.style }}
        {...props.tdProps}
        colSpan={1}
        className={`table-cell ${props.className}`}
      >
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  return (
    <>
      {FlightBookingList && FlightBookingList.length > 0 ? (
        <ExcelExport
          data={
            filter ? filterBy(FlightBookingList, filter) : FlightBookingList
          }
          ref={exportRef}
          fileName={`Flight Booking  ${moment().format(
            "DD-MM-YYYY HH-mm"
          )}.xlsx`}
        >
          <KendoGrid
            style={{ maxHeight: "calc(100vh - 464px)" }}
            filterable={true}
            filter={filter}
            data={
              filter ? filterBy(FlightBookingList, filter) : FlightBookingList
            }
            total={
              FlightBookingList[0]?.TotalRecord || FlightBookingList.length
            }
            onFilterChange={handleFilterChange}
            skip={currentPage * pageLimit}
            take={pageLimit}
            pageable={{
              buttonCount: 5,
              pageSizes: [10, 50, 100, 300, 500],
              pageSizeValue: pageLimit,
              type: "input",
            }}
            onPageChange={pageChange}
            cells={{
              headerCell: HeaderCustomCell,
              data: MyDataCustomCell,
            }}
            className={`responsive-table flight-booking-table`}
            // resizable={true}
          >
            {/* <Column
            field="flight_booking_guid"
            width={120}
            locked={true}
            title="Actions"
            cell={MyEditCommandCell}
            filterable={false}
          /> */}
            <Column field="BookingDate" title="Booking Date" width={80} />
            <Column
              field="BookingNo"
              title="Booking No"
              // locked={true}
              width={75}
              cell={(props: any) => (
                <td
                  style={{
                    ...props.style,
                  }}
                  className={`hoverableName ${props.className}`}
                >
                  <Link
                    className="hoverableName"
                    to={`view/${props.dataItem?.PortalBookingNo}`}
                    type="button"
                    style={{ color: "green", fontWeight: "bold" }}
                    // target="_blank"
                  >
                    {props.dataItem?.BookingNo}
                  </Link>
                </td>
              )}
            />
            <Column
              field="PortalBookingNo"
              title="Po. Booking No"
              // locked={true}
              cell={(props: any) => (
                <td
                  style={{
                    ...props.style,
                  }}
                  className={`hoverableName ${props.className}`}
                >
                  <Link
                    className="hoverableName"
                    to={`view/${props.dataItem?.PortalBookingNo}`}
                    type="button"
                    style={{ color: "green", fontWeight: "bold" }}
                    // target="_blank"
                  >
                    {props.dataItem?.PortalBookingNo}
                  </Link>
                </td>
              )}
              width={80}
            />
            <Column field="AirlinePNR" title="Airline PNR" width={85} />
            <Column field="Airline" title="Airline" width={80} />
            <Column field="FlightNo" title="Flight No" width={85} />
            <Column field="Itinerary" title="Itinerary" width={80} />
            <Column field="TravelDate" title="Travel Date" width={80} />
            <Column field="PassengerName" title="Passenger Name" width={100} />
            <Column field="mobile_no" title="Mobile No" width={75} />
            <Column
              field="TotalPax"
              title="Total Pax"
              cell={(props: GridCellProps) => (
                <td
                  style={{
                    ...props.style,
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  {props?.dataItem?.TotalPax}
                </td>
              )}
              width={70}
            />
            <Column
              field="CancellationPax"
              title="Can. Pax"
              cell={(props: GridCellProps) => (
                <td
                  style={{
                    ...props.style,
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  {props?.dataItem?.CancellationPax}
                </td>
              )}
              width={60}
            />
            <Column
              field="RemainingPax"
              title="Rem. Pax"
              cell={(props: GridCellProps) => (
                <td
                  style={{
                    ...props.style,
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  {props?.dataItem?.RemainingPax}
                </td>
              )}
              width={60}
            />
            <Column
              field="GrossValue"
              title="Gross Value"
              cell={(props: GridCellProps) => (
                <td
                  style={{
                    ...props.style,
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  ₹ {props?.dataItem?.GrossValue}
                </td>
              )}
              width={70}
            />
            <Column field="BookingBy" title="Book By" width={80} />
            <Column
              field="CancelledAmount"
              title="Can. Amt"
              cells={{
                data: (props: GridCellProps) => (
                  <td
                    style={{
                      ...props.style,
                      textAlign: "center",
                      fontWeight: "bold",
                    }}
                  >
                    ₹ {props?.dataItem?.CancelledAmount}
                  </td>
                ),
              }}
              width={70}
            />
            <Column field="PaymentRefNo" title="Payment Ref No" width={110} />
            <Column field="PaymentMode" title="Payment Mode" width={80} />
            <Column
              field="BookingStatus"
              width={80}
              title="Booking Status"
              // cell={(props: GridCellProps) => {
              //   return (
              //     <td
              //       style={{
              //         ...props.style,
              //         textAlign: "center",
              //       }}
              //     >
              //       {props?.dataItem?.booking_status === "CONFIRMED" && (
              //         <>
              //           <Typography.p
              //             style={{
              //               color: "forestgreen",
              //               fontWeight: "bold",
              //               padding: "2px 10px",
              //               width: "fit-content",
              //               backgroundColor: "#DFF8DC",
              //               borderRadius: "10px",
              //               margin: 0,
              //             }}
              //           >
              //             Confirmed
              //           </Typography.p>
              //         </>
              //       )}
              //     </td>
              //   );
              // }}
            />
            {(isEmailSendAccess || isWhatsAppSendAccess) && (
              <Column
                field="ID"
                title="Actions"
                cells={{
                  data: (props: GridCellProps) => (
                    <td
                      style={{
                        ...props.style,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {isEmailSendAccess && (
                          <IconButton
                            type="button"
                            fillMode="flat"
                            size="small"
                            title="Send Email"
                            onClick={() =>
                              dispatch(
                                sendMailByBookingNo(
                                  props.dataItem.PortalBookingNo
                                )
                              )
                            }
                          >
                            <MdMail
                              className="absolute-position"
                              style={{ cursor: "pointer", fontSize: 16 }}
                            />
                          </IconButton>
                        )}
                        {isWhatsAppSendAccess && (
                          <IconButton
                            type="button"
                            fillMode="flat"
                            size="small"
                            title="Send Whatsapp"
                            onClick={() =>
                              dispatch(
                                sendWhatsappByBookingNo(
                                  props.dataItem.PortalBookingNo
                                )
                              )
                            }
                          >
                            <IoLogoWhatsapp
                              className="absolute-position"
                              style={{ cursor: "pointer", fontSize: 16 }}
                            />
                          </IconButton>
                        )}
                      </div>
                    </td>
                  ),
                }}
                width={90}
              />
            )}
          </KendoGrid>
        </ExcelExport>
      ) : (
        <AlertBox />
      )}
    </>
  );
};

const OptionWiseFlightBookingGridComponent: React.FC = () => {
  const FlightBookingListByOptions = useAppSelector(
    (state) => state.flightBooking.FlightBookingListByOptions
  );

  const navigate = useNavigate();

  // const items = [
  //   "Download Ticket",
  //   "Download Invoice",
  //   "Cancel Booking",
  //   // "View",
  // ];

  const [ticketLoading, setTicketLoading] = useState<any>(false);
  const [invoiceLoading, setInvoiceLoading] = useState<any>(false);

  const handleDownloadPdf = async (
    Booking_RefNo: string,
    Airline_PNR: string
    // index: number
  ) => {
    try {
      // if (isMultiPnr) {
      //   setTicketLoadingIndexes((prev) => [...prev, index]);
      // } else {
      setTicketLoading(true);
      // }
      const Request_Id = getRequestId();

      const response = await fetch(`${API_URL}/AirlineReprint/Air_ReprintPDF`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Booking_RefNo,
          Airline_PNR,
          IsPayment: false,
          Request_Id,
        }),
      });

      if (!response.ok) {
        ErrorToast("Failed to generate PDF! - Please try after some time");
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `Ticket-${Airline_PNR}.pdf`;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      ErrorToast("Failed to download Ticket! - Please try again later");
    } finally {
      // if (isMultiPnr) {
      //   setTicketLoadingIndexes((prev) => prev.filter((i) => i !== index));
      // } else {
      setTicketLoading(false);
      // }
    }
  };

  const handleDownloadInvoice = async (
    Booking_RefNo: string,
    Airline_PNR: string
    // index: number
  ) => {
    try {
      // if (isMultiPnr) {
      //   setInvoiceLoadingIndexes((prev) => [...prev, index]);
      // } else {
      setInvoiceLoading(true);
      // }

      const Request_Id = getRequestId();

      const response = await fetch(
        `${API_URL}/AirlineReprint/Air_ReprintInvoice`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            Booking_RefNo,
            Airline_PNR,
            IsPayment: false,
            Request_Id,
          }),
        }
      );

      if (!response.ok) {
        ErrorToast("Failed to generate PDF! - Please try after some time");
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `Invoice-${Airline_PNR}.pdf`;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      ErrorToast("Failed to download Invoice! - Please try again later");
    } finally {
      // if (isMultiPnr) {
      //   setInvoiceLoadingIndexes((prev) => prev.filter((i) => i !== index));
      // } else {
      setInvoiceLoading(false);
      // }
    }
  };

  const handleItemClick = (
    event: any,
    Booking_RefNo: string,
    Airline_PNR: string
  ) => {
    const clickedItem = event?.item;

    if (clickedItem === "Download Ticket") {
      handleDownloadPdf(Booking_RefNo, Airline_PNR);
    } else if (clickedItem === "Download Invoice") {
      handleDownloadInvoice(Booking_RefNo, Airline_PNR);
    } else if (clickedItem === "Cancel Booking") {
      navigate(
        `/flightbooking/cancel?bookingId=${Booking_RefNo}&airlinepnr=${Airline_PNR}`
      );
    }
  };

  return (
    <>
      {FlightBookingListByOptions && FlightBookingListByOptions.length > 0 ? (
        <>
          {FlightBookingListByOptions.map((booking: any) =>
            booking?.PNR_Wise_Details.map(
              (pnrDetail: any, pnrIndex: number) => (
                <ShadowCard
                  style={{
                    boxShadow: "none",
                    border: "1px solid green",
                    marginBottom: 10,
                  }}
                  key={pnrIndex}
                >
                  <GridLayout
                    style={{
                      marginRight: "20px",
                      paddingTop: 10,
                    }}
                    gap={{ rows: 0, cols: 10 }}
                    cols={[
                      { width: "33.33%" },
                      { width: "33.33%" },
                      { width: "33.33%" },
                    ]}
                  >
                    <GridLayoutItem>
                      <Typography.h6 className="mb-2">
                        Booking Date: {booking?.BookingDate}
                      </Typography.h6>
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Typography.h6 className="mb-2">
                        Portal Booking No: {booking?.PortalBookingNo}
                      </Typography.h6>
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Typography.h6 className="mb-2">
                        Booking No: {booking?.BookingNo}
                      </Typography.h6>
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Typography.h6 className="m-0">
                        Airline: {pnrDetail?.Airline || "Indigo"}
                      </Typography.h6>
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Typography.h6 className="m-0">
                        Airline PNR: {pnrDetail?.AirlinePNR}
                      </Typography.h6>
                    </GridLayoutItem>
                    <GridLayoutItem className="d-flex gap-2 align-items-center justify-content-between">
                      <Typography.h6 className="m-0">
                        Gross Value: ₹{" "}
                        {formatIndianNumber(pnrDetail?.GrossValue)}
                      </Typography.h6>
                      <DropDownButton
                        popupSettings={{
                          anchorAlign: {
                            horizontal: "right",
                            vertical: "bottom",
                          },
                          popupAlign: {
                            horizontal: "right",
                            vertical: "top",
                          },
                        }}
                        disabled={invoiceLoading || ticketLoading}
                        onItemClick={(e) =>
                          handleItemClick(
                            e,
                            booking?.PortalBookingNo,
                            pnrDetail?.AirlinePNR
                          )
                        }
                        text="Actions"
                        title="Actions"
                        items={[
                          "Download Ticket",
                          "Download Invoice",
                          pnrDetail?.TotalPax > pnrDetail?.CancellationPax &&
                            moment(booking.travelDate).isAfter(moment()) &&
                            "Cancel Booking",
                        ].filter(Boolean)}
                        themeColor={"primary"}
                      />
                    </GridLayoutItem>
                  </GridLayout>
                </ShadowCard>
              )
            )
          )}
        </>
      ) : (
        <AlertBox />
      )}
    </>
  );
};

export default FlightBooking;
